
import { Component, Prop, Vue } from 'bits/vue'

export enum OzBadgeColorScheme {
  Bare = 'Bare',
  Default = 'Default',
  Selection = 'Selection',
  Disabled = 'Disabled',
}

export enum OzBadgeSizePreset {
  Bare = 'Bare',
  Default = 'Default',
}

@Component({})
export default class OzBadge extends Vue {
  OzBadgeColorScheme = OzBadgeColorScheme
  OzBadgeSizePreset = OzBadgeSizePreset

  /**
   * Dark mode.
   */
  @Prop({ default: 'auto' }) darkMode?: true | false | 'auto'

  /**
   * Text
   */
  @Prop({ required: true }) text!: string

  /**
   * Color scheme.
   *
   *
   * **Default**
   *
   * - Light mode: grey-700
   * - Dark mode: grey-200
   *
   *
   * **Selection**
   *
   * - Light mode: grape-500
   * - Dark mode: canary-500
   *
   *
   * **Disabled**
   *
   * - Light mode: dark-text-300
   * - Dark mode: light-text-300
   */
  @Prop({ required: true }) colorScheme!: OzBadgeColorScheme

  /**
   * Size preset.
   *
   *
   * Determines the font-size
   */
  @Prop({ default: OzBadgeSizePreset.Default }) sizePreset?: OzBadgeSizePreset
}
